export default __webpack_public_path__ + "static/media/58.08cb626d.png";